import isEmpty from "lodash/isEmpty";
const mapConsentsToOrderModel = (consents) => {
  if (isEmpty(consents)) {
    return void 0;
  }
  const consentsGiven = consents.filter((consent) => consent.isChecked === true);
  return consentsGiven.reduce(
    (result, consent) => ({
      ...result,
      [consent.value]: {
        uiType: "checkbox",
        literalText: consent.title
      }
    }),
    {}
  );
};
export {
  mapConsentsToOrderModel
};
//# sourceMappingURL=map-consent-to-order-model.js.map
